<template>
  <div class="app-container">
    <div class="filter-container">
      <div>
        <el-button type="primary" @click="goEdit(0)" class="filter-item"
          >新增</el-button
        >
        <el-input
          v-model="listQuery.title"
          placeholder="请输入标题"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
          >搜索</el-button
        >
      </div>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="资讯标题" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>
      <el-table-column label="资讯发布时间" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="资讯图片" min-width="100" align="center">
        <template slot-scope="scope">
          <el-image
            style="height: 80px"
            :preview-src-list="[scope.row.cover]"
            :src="scope.row.cover"
            class="banner-image"
            lazy
          />
        </template>
      </el-table-column>
      <!-- <el-table-column label="权重" min-width="60" align="center">
        <template slot-scope="scope">
          {{ scope.row.weight }}
        </template>
      </el-table-column> -->
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="goEdit(scope.row.id)">
            修改
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDel(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        title: "",
        start_datetime: "",
        end_datetime: "",
        is_on: "",
      },
      start_datetime: "",
      end_datetime: "",
      industries: [],
      industrie_detaileds: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      this.listQuery.start_datetime = this.start_datetime
        ? this.start_datetime + " 00:00:00"
        : "";
      this.listQuery.end_datetime = this.end_datetime
        ? this.end_datetime + " 23:59:59"
        : "";
      request({
        url: "/api/backend/information/list",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        console.log(this.list);
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    closeIndustrie() {
      this.industrie_detaileds = [];
      this.listQuery.industry_detailed_id = "";
    },

    goEdit(id) {
      if (id) {
        this.$router.push("/website/informationAdminEdit?id=" + id);
      } else {
        this.$router.push("/website/informationAdminEdit");
      }
    },
    handleDel(id) {
      this.$confirm("确定要删除, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/information/del",
            method: "post",
            data: { id: id },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    getIndustrie(parent_id) {
      return request({
        url: "/api/common/industry/list",
        method: "get",
        params: {
          parent_id: parent_id,
        },
      }).then((res) => {
        this.industrie_detaileds = [];
        if (parent_id) {
          this.industrie_detaileds = res.data;
        } else {
          this.industries = res.data;
        }
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    upDown(id) {
      request({
        url: "/api/backend/sys/notice/upDown",
        method: "post",
        data: { id: id },
      }).then(() => {
        this.getList();
        this.$message({
          type: "success",
          message: "操作成功!",
        });
      });
    },
    handleForbid(val, text) {
      this.$confirm("此操作将" + text + "该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/roadshowActivity/upDown",
            method: "get",
            params: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.button:first-child {
  margin-left: 10px;
}
.button {
  margin-bottom: 10px;
}
</style>
